import { observatoryCountriesHeatMap, observatoryNormalizedCountriesHeatMap } from '../lib/countries.js';
import { seriesEsp, seriesEng, seriesId, countriesDataEng, countriesDataEsp } from './translations/translations_observatorio_internacional_heatmap.js';
import { translateSeries } from '../lib/translate_series_name.js'

export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = 'SELECT * FROM observatorio_internacional_heatmap';
            const gobiertoPath = process.env.GOBIERTO_DATA_URL
            const token = process.env.GOBIERTO_DATA_TOKEN
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: data => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, null, null, null, null)
            const series = this.series.map(d => ({
              id: d.id,
              name: d.name
            }));

            const { data: rawData } = data

            const normalizedData = rawData.map(({ pais, tipo, ...rest }) => {
              return {
                country: pais,
                developed_country: tipo,
                ...rest
              }
            })

            normalizedData.map(d => {
              const { country } = d

              const indexNormalizedCountries = observatoryCountriesHeatMap.findIndex(element => element === country);

              if (indexNormalizedCountries >= 0) {
                d.country = observatoryNormalizedCountriesHeatMap[indexNormalizedCountries];
              }
            })

            normalizedData.map(d => {
              const { country, developed_country } = d
              if(country) {
                const selectedLanguage = document.documentElement.lang === 'es' ? countriesDataEsp : countriesDataEng
                const indexCountry = countriesDataEsp.findIndex(element => element === country);
                d.country = selectedLanguage[indexCountry]
              }

              if(d.developed_country) {
                d.developed_country =
                  document.documentElement.lang !== 'es' && developed_country === "desarrollado"
                  ? "developed"
                  : document.documentElement.lang !== 'es' && developed_country === "emergente"
                  ? "developing"
                  : developed_country;
              }
            })
            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map(set =>
              normalizedData.map(d => ({
                serie: set.id,
                time: d.ano_rango,
                value: parseFloat(d[set.id]),
                name: set.name,
                country: d.country,
                developed_country: d.developed_country
              }))
            );

            const groupData = {
              groups: groupBySerie.flat(),
              raw: normalizedData
            }

            return groupData;
          }
        }
      }
    };
  }

  setDefaults = () => {
    this.series = [
      {
        "id": "dce",
        "name": "Dinámica del crecimiento económico",
        "units": "u.",
        "group": ""
      },
      {
        "id": "ci",
        "name": "Calidad institucional",
        "units": "u.",
        "group": ""
      },
      {
        "id": "dmse",
        "name": "Dinámica monetaria y de sector exterior",
        "units": "u.",
        "group": ""
      },
      {
        "id": "dde",
        "name": "Dinámica del endeudamiento",
        "units": "u.",
        "group": ""
      }
    ];

    this.CHARTS_DEFAULT = [{
      type: "HeatMap",
      showScales: false,
      hasContainer: true,
      countries: "todos"
    }];
  };

}
